




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DeploymentsTable from './DeploymentsTable.vue';
import { deploymentSvc, UtilService } from '@/services';

@Component({
  name: 'deployment-values-editor',
  components: {}
})
export default class DeploymentValuesEditor extends Vue {
  @Prop({ required: true, type: String })
  deploymentId!: string;

  isLoading: boolean = false;
  values: string = '';
  validateState: boolean = true;

  created() {
    this.loadValues();
  }

  async loadValues() {
    this.isLoading = true;
    try {
      const resp = await deploymentSvc.getValues(this.deploymentId);
      this.values = UtilService.formatJson(resp);
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
    }
  }

  onInput() {
    this.validate();
  }

  validate() {
    this.validateState = UtilService.isJson(this.values);
    return this.validateState;
  }

  cancel() {
    this.$emit('cancel');
  }

  async save() {
    try {
      await this.$confirm(
        'This is an extremely dangerous operation, it could potentially break production instance of this deployment. Are you SURE to save the values?',
        'Warning',
        {
          confirmButtonText: 'Yes, I know what I am doing.',
          cancelButtonText: 'No, Let me think about it.',
          type: 'warning'
        }
      );
    } catch (e) {
      return false;
    }

    try {
      this.isLoading = true;
      const resp = await deploymentSvc.updateValues(
        this.deploymentId,
        this.values
      );
      this.$emit('saved');
      this.$notify.success(
        'Deployment Values has been updated, but you still need to run a deploy to make them effect.'
      );
      this.isLoading = false;
    } catch (e) {
      this.$notify.error('Failed to update deployment values.');
      this.isLoading = false;
    }
  }
}
